import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import { newAlert } from '../../../actions/alert_actions';
import {
  setNextStep,
  checkDigitalSaleSignedUnmaterializedPromissory
} from '../../../actions/portal_financing_actions';
import { setCurrentStep } from '../../../actions/stepper_actions';
import DigitalSaleOTPPromissory from './DigitalSaleOTPPromissory';

function mapStateToProps(state) {
  const pf = state.portalFinancing;

  return {
    process: state.stepper.process,
    digitalSaleWithUUPNext: state.stepper.digitalSaleWithUUPNext,
    digitalSaleWithouFaceIdNext: state.stepper.digitalSaleWithouFaceIdNext,
    digitalSaleWithoutUUPonContractNext:
      state.stepper.digitalSaleWithoutUUPonContractNext,
    serverErrors: pf.errors,
    contract: pf.debtor_contract_number,
    digitalSaleWithPUI: pf.digital_sale_with_pui,
    routes: state.stepper.routes,
    tempPromissory: pf.tempPromissory,
    debtorIdentification: pf.debtor_identification,
    debtorIdentificationType: pf.debtor_identification_type,
    debtorSignUrl: pf.debtorSignUrl,
    unmaterializedProcessId: pf.unmaterializedProcessId,
    promissoryUrl: pf.promissory_url,
    promissoryId: pf.promissory_id,
    loading: pf.stepIsLoading,
    documentSerial: pf.documentSerialV2,
    orgDataLoading: state.requestState.requestOrgDataSend,
    previewPromissoryLoading: state.requestState.requestPreviewDocumentSend,
    requestSendOtpV2: state.requestState.requestSendV2OtpSend
  };
}

function mapDispatchToProps(dispatch) {
  return {
    newAlert: bindActionCreators(newAlert, dispatch),
    setCurrentStep: bindActionCreators(setCurrentStep, dispatch),
    setNextStep: bindActionCreators(setNextStep, dispatch),
    checkDigitalSaleSignedUnmaterializedPromissory: bindActionCreators(
      checkDigitalSaleSignedUnmaterializedPromissory,
      dispatch
    )
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(DigitalSaleOTPPromissory);
